import { render, staticRenderFns } from "./x-query-select.component.vue?vue&type=template&id=d4c6a028&scoped=true"
import script from "./x-query-select.component.vue?vue&type=script&lang=ts"
export * from "./x-query-select.component.vue?vue&type=script&lang=ts"
import style0 from "./x-query-select.component.vue?vue&type=style&index=0&id=d4c6a028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c6a028",
  null
  
)

export default component.exports